<ng-template #recursiveNode let-nodes>
  @for (node of nodes; track node) {
    <div class="node" [attr.data-node-id]="node.id" [attr.data-spec-id]="node.type === 'item' ? node.id : null">
      <div class="node-box" (mouseenter)="nodeHovered(node, $event)">
        <div class="node-header" (click)="toggleNode(node.id)">
          <div class="chevron">
            <fa-icon [icon]="faChevronRight" [ngClass]="{'expanded': nodeIsExpanded[node.id]}"></fa-icon>
          </div>
          @if (node.type === 'group' && specGroupsById[node.id]; as group) {
            <!--          <div class="numbering">{{ group.displayId }}</div>-->
            <wm-editable-inlinetext [size]="6" class="numbering" placeholder="" [(ngModel)]="group.displayId" (onSave)="saveSpecGroupDisplayId(group.id, $event)"></wm-editable-inlinetext>
            @if (!editedNodeTitles[node.id]) {
              <div class="title">
                <div [innerHTML]="group.name"></div>
                @if (!readonly) {
                  <p-button class="edit-button" styleClass="p-button-text" icon="true" pTooltip="Edit group title" (click)="editNodeTitle(node.id, group.name); $event.stopPropagation();"><fa-icon [icon]="faEdit" ></fa-icon></p-button>
                }
              </div>
            }
            @if (editedNodeTitles[node.id]) {
              <div class="title">
                <input pInputText [attr.data-title-edit-input]="node.id" [ngModel]="editedNodeTitles[node.id].content" (ngModelChange)="editedNodeTitles[node.id].content = $event" (click)="$event.stopPropagation()"/>
                <p-button icon="true" (click)="saveNodeName(node); $event.stopPropagation();"><fa-icon [icon]="faSave" ></fa-icon></p-button>
                <p-button styleClass="p-button-text" icon="true" (click)="cancelSaveSectionTitle(node.id); $event.stopPropagation();"><fa-icon  [icon]="faTimes" ></fa-icon></p-button>
              </div>
            }
            @if (!readonly && nodeIsExpanded[node.id]) {
              <div class="actions">
                <p-button styleClass="p-button-text" icon="true"  pTooltip="Add group spec" [showDelay]="1000" tooltipPosition="left" (click)="createSpecGroup(node.id); $event.stopPropagation();">
                  <fa-icon [icon]="$any(plusDown)"></fa-icon>
                </p-button>
                <p-button styleClass="p-button-text" icon="true"  pTooltip="Add child spec" [showDelay]="1000" tooltipPosition="left" (click)="addChildSpec(node.id); $event.stopPropagation();">
                  <fa-icon [icon]="$any(plusRightDown)"></fa-icon>
                </p-button>
                <p-button styleClass="p-button-text p-button-danger" icon="true" pTooltip="Delete spec group" [showDelay]="1000" tooltipPosition="left" (click)="deleteSpecGroup(node.id); $event.stopPropagation();">
                  <fa-icon [icon]="faTrash"></fa-icon>
                </p-button>
              </div>
            }
          }
          @if (node.type === 'item' && specsById[node.id]; as spec) {
            <wm-editable-inlinetext [size]="6" class="numbering" placeholder="" [(ngModel)]="spec.displayId" (onSave)="saveSpecDisplayId(spec.id, $event)"></wm-editable-inlinetext>
            @if (!editedNodeTitles[node.id]) {
              <div class="title">
                <div [innerHTML]="spec.title"></div>
                @if (!readonly) {
                  <p-button class="edit-button" styleClass="p-button-text" icon="true" pTooltip="Edit section title"  (click)="!readonly && editNodeTitle(node.id, spec.title); $event.stopPropagation();"><fa-icon [icon]="faEdit" ></fa-icon></p-button>
                }
              </div>
            }
            @if (editedNodeTitles[node.id]) {
              <div class="title">
                <input pInputText [attr.data-title-edit-input]="node.id" [ngModel]="editedNodeTitles[node.id].content" (ngModelChange)="editedNodeTitles[node.id].content = $event" (click)="$event.stopPropagation()"/>
                <p-button icon="true" (click)="saveNodeName(node); $event.stopPropagation();"><fa-icon [icon]="faSave" ></fa-icon></p-button>
                <p-button styleClass="p-button-text" icon="true" (click)="cancelSaveSectionTitle(node.id); $event.stopPropagation();"><fa-icon  [icon]="faTimes" ></fa-icon></p-button>
              </div>
            }
            @if (!readonly && nodeIsExpanded[node.id]) {
              <div class="labels">
                @if ((spec.labels?.length || 0) <= 3) {
                  <wm-tags [tags]="spec.labels" [onlyLocal]="true" (tagsChanged)="saveSpecLabels(spec.id, $event)"></wm-tags>
                }
                @if ((spec.labels?.length || 0) > 3) {
                  <div class="overflow-container" (click)="labelsOverflow.toggle($event); $event.stopPropagation();">
                    {{ spec.labels.length }} tags...
                  </div>
                }
                <p-popover #labelsOverflow [dismissable]="true" [showCloseIcon]="true" appendTo="body" [trigger]="overflowButton">
                  <wm-tags [tags]="spec.labels" [onlyLocal]="true" (tagsChanged)="saveSpecLabels(spec.id, $event)"></wm-tags>
                </p-popover>
              </div>
            }
            @if (!readonly && nodeIsExpanded[node.id]) {
              <div class="actions">
                <p-button styleClass="p-button-text p-button-danger" icon="true" pTooltip="Delete spec" [showDelay]="1000" tooltipPosition="left" (click)="deleteSpec(node.id); $event.stopPropagation();">
                  <fa-icon [icon]="faTrash"></fa-icon>
                </p-button>
              </div>
            }
          }
        </div>
        @if (nodeIsExpanded[node.id]) {
          <div class="node-content">
            @if (node.type === 'group' && specGroupsById[node.id]; as group) {
              <wm-editable-text [readonly]="readonly" [(ngModel)]="group.description" (onTextChange)="updateGroupDescription(group.id, $event)"></wm-editable-text>
            }
            @if (node.type === 'item' && specsById[node.id]; as spec) {
              <wm-editable-text [readonly]="readonly" [(ngModel)]="spec.description" (onTextChange)="updateSpecDescription(spec.id, $event)"></wm-editable-text>
            }
          </div>
        }
      </div>
      @if ((node.children || []).length > 0 && nodeIsExpanded[node.id]) {
        <div class="subnodes">
          <ng-container *ngTemplateOutlet="recursiveNode; context:{ $implicit: node.children }"></ng-container>
        </div>
      }
    </div>
  }
</ng-template>

<div class="nodes" #nodesContainer (mouseleave)="hideNodeActions()">
  <ng-container *ngTemplateOutlet="recursiveNode; context:{ $implicit: specForest }"></ng-container>
</div>

@if (loadingSpecs) {
  <div class="loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

@if (!loadingSpecs && (specForest?.length || 0) === 0) {
  <div class="empty">
    @if (specForest.length === 0) {
      <div class="empty-text">No specs available</div>
    }
    @if (!readonly) {
      <p-button label="Create First Spec" (click)="createSpecGroup()"></p-button>
    }
  </div>
}
